import { inject, Injectable } from '@angular/core';
import { UseCase } from '@shared/helper';
import { GetClaimVoucherDto, GetClaimVoucherResp } from './get-claim-voucher.type';
import { PromoRepository } from '../../../repositories/promo.repository';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class GetClaimVoucherUsecase implements UseCase<GetClaimVoucherDto, GetClaimVoucherResp> {
    private readonly promoRepository = inject(PromoRepository);

    execute(params: GetClaimVoucherDto): Observable<GetClaimVoucherResp> {
        return this.promoRepository.GetClaimVoucher(params);
    }
}